<template>
    <v-stepper-header v-if="questions.length < 10">
        <template v-for="(step, n) in questions" > 
            <v-stepper-step :complete="e1 > (n + 1)" :step="(n + 1)" :key="n"></v-stepper-step>

            <v-divider v-if="n !== (questions.length - 1)" :key="'divider' + n"></v-divider>
        </template>
    </v-stepper-header>
    <v-stepper-header v-else>
        <template> 
          <v-divider v-if="e1 > 1" ></v-divider>
          <v-stepper-step :complete="questions[e1 -1] ==  null || questions[e1 -1].answer > 0" :step="e1"></v-stepper-step>
          <v-divider v-if="e1 < questions.length + 1" ></v-divider>
        </template>
    </v-stepper-header>
</template>

<script>
export default {
    name: 'questionaire-card-header',
    props: ['e1', 'questions']
}
</script>